import { Center } from "@mantine/core";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { useController, useFormContext } from "react-hook-form";

import { StyledWeek } from "./styled.Week";
import { useSelector } from "../../redux/hooks";
import { useEffect } from "react";

dayjs.extend(weekOfYear);

interface Props {
  id: string;
  value: string;
  feature?: string;
}

const Week = ({ id, value, feature }: Props) => {
  const { control, setValue } = useFormContext();
  const { features } = useSelector(state => state.generatorSlice);
  const currentDate = dayjs();
  const weekNumber = currentDate.week();
  const currentYear = currentDate.year();
  const { field } = useController({
    control,
    name: id,
    defaultValue: value || String(weekNumber),
  });
  useEffect(() => {
    if (feature && features[feature]) {
      setValue(id, features[feature]);
    }
  }, [features, feature]);
  return (
    <Center>
      <StyledWeek {...field} />
      <p style={{ marginLeft: "5px" }}>Of {currentYear}</p>
    </Center>
  );
};

export default Week;
